import getCountryByPhoneNumber from '../getCountryByPhoneNumber';
import { CountryItem } from '../types';

const extractCodeFromNumber = (
  items: CountryItem[],
  value: string
): string | undefined => getCountryByPhoneNumber(items, value)?.phoneCode;

export default extractCodeFromNumber;
